import { useState } from 'react';
import { Image } from 'react-bootstrap';
import './IntegrationPromoCode.css';
import IntegrationPromoCodeImage from '../../Images/integrationPromoCode.png';

const IntegrationPromoCode = ({ promoCode }) => {
  const [copyText, setCopyText] = useState('Copy');

  const handleCopy = () => {
    navigator.clipboard.writeText(promoCode)
      .then(() => {
        setCopyText('Copied!');
        setTimeout(() => setCopyText('Copy'), 2000);
      })
      .catch((err) => {
        console.error('Failed to copy promo code: ', err);
      });
  };

  return (
    <div className="integration-promo-container">
      <div className="promo-text-container">
        <div className="promo-text">
          <p className='promo-bold'>{promoCode}</p>
          <span 
            onClick={handleCopy} 
            className="promo-copy underline"
          >
            {copyText}
          </span>
        </div>    
        <p style={{color: '#999999', marginTop: "20px"}}>
          To complete the integration setup, please apply the above promo code when prompted.
        </p>
      </div>
      <Image className="integration-image-container" src={IntegrationPromoCodeImage} alt="Integration Promo Code" />
    </div>
  );
}

export default IntegrationPromoCode;